import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  en: {
    "nav.home": "Home",
    "nav.portfolio": "Portfolio",
    "nav.prewedding": "Gallery",
    "nav.reels": "Reels",
    "nav.services": "Services",
    "nav.blog": "Blog",
    "nav.about": "About",
    "nav.book": "Book",
    "hero.overline": "Bengali Wedding Photography — Est. 2018",
    "hero.title.1": "Prem, alo o",
    "hero.title.2": "golpo",
    "hero.title.3": ".",
    "hero.sub": "Wedding Touch — a Kolkata based studio crafting cinematic Bengali weddings, pre-wedding stories and portraits. Love, in the language it deserves.",
    "hero.cta.book": "Book a session",
    "hero.cta.portfolio": "View portfolio →",
    "home.selected": "Selected Work",
    "home.selected.title": "Chapters, not shoots.",
    "home.selected.all": "All work →",
    "home.philosophy": "Our Philosophy",
    "home.quote": "\"We don't take pictures. We keep",
    "home.quote.accent": "time",
    "home.quote.end": "— one honest frame at a time.\"",
    "reels.overline": "Cinematic",
    "reels.title": "Reels & Films.",
    "reels.sub": "Short cinematic edits from our recent weddings and portrait sessions.",
    "reels.play": "Play video",
    "prewed.overline": "Pre-Wedding Stories",
    "prewed.title.1": "The",
    "prewed.title.2": "before",
    "prewed.title.3": "chapter.",
    "prewed.sub": "Tulips, red silk, whispered conversations in old gardens. Pre-wedding shoots designed as cinematic short stories — not stiff poses.",
    "prewed.ready": "Ready to plan yours?",
    "prewed.cta": "Book pre-wedding session",
    "portfolio.overline": "Portfolio",
    "portfolio.title": "The archive.",
    "services.overline": "Services & Investment",
    "services.title": "Packages, tailored.",
    "about.overline": "About the studio",
    "about.title": "A quiet obsession with light.",
    "contact.overline": "Book a session",
    "contact.title.1": "Tell us about",
    "contact.title.2": "your",
    "contact.title.3": "story",
    "blog.overline": "Journal",
    "blog.title": "Stories & guides.",
    "testimonials.overline": "Kind Words",
    "testimonials.title.1": "What couples",
    "testimonials.title.2": "say",
    "lang.toggle": "বাংলা",
  },
  bn: {
    "nav.home": "হোম",
    "nav.portfolio": "পোর্টফোলিও",
    "nav.prewedding": "গ্যালারি",
    "nav.reels": "রিলস",
    "nav.services": "সার্ভিস",
    "nav.blog": "ব্লগ",
    "nav.about": "আমরা",
    "nav.book": "বুক করুন",
    "hero.overline": "বাঙালি বিয়ের ফটোগ্রাফি — ২০১৮ থেকে",
    "hero.title.1": "প্রেম, আলো ও",
    "hero.title.2": "গল্প",
    "hero.title.3": "।",
    "hero.sub": "ওয়েডিং টাচ — কলকাতার একটি স্টুডিও, যেখানে বাঙালি বিয়ে, প্রি-ওয়েডিং ও পোর্ট্রেট সিনেম্যাটিকভাবে ধরা হয়। ভালোবাসা, তার নিজের ভাষায়।",
    "hero.cta.book": "সেশন বুক করুন",
    "hero.cta.portfolio": "পোর্টফোলিও দেখুন →",
    "home.selected": "নির্বাচিত কাজ",
    "home.selected.title": "শুধু ছবি নয়, অধ্যায়।",
    "home.selected.all": "সব কাজ →",
    "home.philosophy": "আমাদের দর্শন",
    "home.quote": "\"আমরা ছবি তুলি না। আমরা ধরে রাখি",
    "home.quote.accent": "সময়",
    "home.quote.end": "— একটা করে সৎ মুহূর্তে।\"",
    "reels.overline": "সিনেম্যাটিক",
    "reels.title": "রিলস ও ফিল্ম।",
    "reels.sub": "আমাদের সাম্প্রতিক বিয়ে ও পোর্ট্রেট সেশনের সংক্ষিপ্ত সিনেম্যাটিক এডিট।",
    "reels.play": "ভিডিও চালান",
    "prewed.overline": "প্রি-ওয়েডিং গল্প",
    "prewed.title.1": "শুরুর",
    "prewed.title.2": "আগে",
    "prewed.title.3": "-র অধ্যায়।",
    "prewed.sub": "টিউলিপ, লাল সিল্ক, পুরনো বাগানের ফিসফিসানি। প্রি-ওয়েডিং শ্যুট — সিনেমার ছোট গল্পের মতো, দাঁড়িয়ে থাকা পোজ নয়।",
    "prewed.ready": "আপনার সেশন পরিকল্পনা করতে প্রস্তুত?",
    "prewed.cta": "প্রি-ওয়েডিং বুক করুন",
    "portfolio.overline": "পোর্টফোলিও",
    "portfolio.title": "সংগ্রহশালা।",
    "services.overline": "সার্ভিস ও প্যাকেজ",
    "services.title": "আপনার জন্য প্যাকেজ।",
    "about.overline": "স্টুডিও সম্পর্কে",
    "about.title": "আলোর প্রতি এক নিঃশব্দ ভালোবাসা।",
    "contact.overline": "সেশন বুক করুন",
    "contact.title.1": "বলুন আমাদের",
    "contact.title.2": "আপনার",
    "contact.title.3": "গল্প",
    "blog.overline": "জার্নাল",
    "blog.title": "গল্প ও গাইড।",
    "testimonials.overline": "ভালো কথা",
    "testimonials.title.1": "দম্পতিরা কী",
    "testimonials.title.2": "বলেন",
    "lang.toggle": "English",
  },
};

const LangContext = createContext({ lang: "en", t: (k) => k, toggle: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => DICT[lang][key] ?? DICT.en[key] ?? key;
  const toggle = () => setLang((l) => (l === "en" ? "bn" : "en"));

  return (
    <LangContext.Provider value={{ lang, t, toggle }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
